module.exports = __webpack_public_path__ + "2ed7223a8e1d1cc605f230bf25c9e061.mp4";